export default {
  stepTitle: {
    id: 'mobile_plan_step_title',
    defaultMessage: 'Select a 5G mobile plan',
  },
  cardGuidanceExternalTelcoTitle: {
    id: 'mobile_plan_step_card_guidance_external_telco_title',
    defaultMessage: 'Add a mobile plan',
  },
  cardGuidanceExternalTelcoLabel: {
    id: 'mobile_plan_step_card_guidance_external_telco_label',
    defaultMessage: 'Get unlimited calls & texts with Vodafone.',
  },
  noMobilePlan: {
    id: 'mobile_plan_step_no_mobile_plan',
    defaultMessage: 'No mobile plan',
  },
  pricePerMonth: {
    id: 'mobile_plan_step_price_per_month',
    defaultMessage: '+{pricePerMonth}/month',
  },
  cancelAnytime: {
    id: 'mobile_plan_step_cancel_anytime',
    defaultMessage: 'Cancel anytime',
  },
  option27GB: {
    id: 'mobile_plan_step_option_27_gb',
    defaultMessage: '27GB plan',
  },
  option15GB: {
    id: 'mobile_plan_step_option_15_gb',
    defaultMessage: '15GB plan',
  },
  option45GB: {
    id: 'mobile_plan_step_option_45_gb',
    defaultMessage: '45GB plan',
  },
  option25GB: {
    id: 'mobile_plan_step_option_25_gb',
    defaultMessage: '25GB plan',
  },
  unlimitedDataPlan: {
    id: 'mobile_plan_step_unlimited_data_plan',
    defaultMessage: 'Unlimited data plan',
  },
  externalTelcoDrawerTitle: {
    id: 'mobile_plan_drawer_external_telco_title',
    defaultMessage: 'Mobile plans',
  },
  contract24Month: {
    id: 'mobile_plan_step_contract_24_month',
    defaultMessage: '24-month contract',
  },
}
